import zlib from 'react-zlib-js';
import customProtocolCheck from 'custom-protocol-check';
import { getPacsEndpoints, getAuthenticationConfig } from './getConfig';

export const getWorkstationURL = (keycloak, layout, config) => {
  const currentLayoutElement = layout.elements[layout.selectedViewIndex] || {};
  const endpoints = getPacsEndpoints(config);
  const authentication = getAuthenticationConfig(config);
  const searchParams = new URLSearchParams({
    messageName: 'OpenStudies',
    requestType: 'CONNECT',
  });

  if (currentLayoutElement.StudyInstanceUID && endpoints.wadoRsEndpoint) {
    searchParams.append('StudyUID', currentLayoutElement.StudyInstanceUID);

    if (endpoints.wadoUriEnabled
      && keycloak?.refreshToken
      && authentication.clientId
      && authentication.authUrl
      && authentication.realm) {
      searchParams.append('dicomWeb', endpoints.wadoRsEndpoint);
      searchParams.append('wadoUri', endpoints.wadoUriEndpoint);
      searchParams.append('authURL', `${authentication.authUrl}/realms/${authentication.realm}/protocol/openid-connect/auth`);
      searchParams.append('tokenURL', `${authentication.authUrl}/realms/${authentication.realm}/protocol/openid-connect/token`);
      searchParams.append('client_id', authentication.clientId);
      searchParams.append('refreshToken', encodeURIComponent(keycloak.refreshToken));

      const query = zlib.deflateSync(searchParams.toString()).toString('base64');
      return `a3dcon://?ahp_enc=${query}`;
    }

    if (endpoints.qidoRsEndpoint && !endpoints.wadoUriEnabled) {
      searchParams.append('QueryString', `qido#${endpoints.qidoRsEndpoint}`);
      searchParams.append('RetrieveString', `wado-rs#${endpoints.wadoRsEndpoint}`);
      return `a3dcon://?${searchParams.toString()}`;
    }
  }

  return null;
};

export const openWorkstationUrl = (workstationUrl) => {
  if (typeof window !== 'undefined') {
    customProtocolCheck(
      workstationUrl,
      () => {
        alert('Alma Workstation is not installed on your computer');
      },
      () => false,
      10000,
      () => {
        alert('Browser not supported to check the presence of the application');
      }
    );
  }
};
